var _title, _desc, _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from 'react';
const SvgComponent = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: "14px",
  height: "15px",
  viewBox: "0 0 14 15",
  version: 1.1,
  xmlnsXlink: "http://www.w3.org/1999/xlink"
}, props), _title || (_title = /*#__PURE__*/React.createElement("title", null, `A5A74494-13BB-486C-B0A6-5502F1776C43`)), _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, `Created with sketchtool.`)), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _g || (_g = /*#__PURE__*/React.createElement("g", {
  id: "In-App-Flow",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  id: "SignlesOnlyPricing",
  transform: "translate(-1073.000000, -822.000000)",
  fill: "#FF5A5A"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group",
  transform: "translate(760.000000, 286.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group-13-Copy",
  transform: "translate(33.000000, 291.000000)"
}, /*#__PURE__*/React.createElement("polygon", {
  id: "\uE88F",
  points: "293.984 247.032 288.416 252.6 293.984 258.168 292.568 259.584 287 254.016 281.432 259.584 280.016 258.168 285.584 252.6 280.016 247.032 281.432 245.616 287 251.184 292.568 245.616"
})))))));
export default __webpack_public_path__ + "static/media/red-x.1be46882.svg";
export { SvgComponent as ReactComponent };